import React, { useState } from 'react';
import '../../css/SimpleAccordion.css';

const SimpleAccordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(prevIndex => prevIndex === index ? null : index);
  };

  return (
    <div className="my-accordion">
      {items.map((item, index) => (
        <div className="my-accordion-item" key={index}>
          <div className="my-accordion-header" onClick={() => toggle(index)}>
            <span className='title'>{item.title}</span>
            <span className={`my-accordion-icon ${activeIndex === index ? 'open' : ''}`}>
              {activeIndex === index ? '–' : '+'}
            </span>
          </div>
          <div className={`my-accordion-content ${activeIndex === index ? 'open' : ''}`}>
            <div className="my-accordion-inner" style={{textTransform:'none'}}>
              {item.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SimpleAccordion;
